import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Arrange, Button, Typography } from "@aviary";
import { EmailInput } from "@shared/components";
import { useBreakpoints } from "@shared/hooks";
import { useLocation } from "@shared/react-router-dom";
import { WellevateAuthWrapper } from "@unauthenticated/shared/components/WellevateAuthWrapper";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import MigrationEmailHero from "@unauthenticated/wellevateAuthorize/patients/assets/images/migration-email-hero-PM19.png";
import { l } from "@unauthenticated/wellevateAuthorize/patients/locales/i18n";

import * as styles from "./WellevateEmailCapture.styles";

const WellevateEmailCapture = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [isEmailDirty, setIsEmailDirty] = useState(false);
  const { tablet } = useBreakpoints();
  const search = useLocation().search;

  const searchParams = search ? `&${new URLSearchParams(search).toString()}` : "";
  const isMobile = tablet.lessThan;

  const handleEmailOnBlur = e => {
    if (e.target.value) {
      setIsEmailDirty(true);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    window.location.assign(
      `${authRoutes.wellevate_patients_authorize}?email=${encodeURIComponent(email)}${searchParams}`
    );
  };

  return (
    <WellevateAuthWrapper>
      <Arrange isVertical isFullwidth>
        <img src={MigrationEmailHero} alt="" />
        <Typography type="h1" sizeOverride={isMobile ? "h4" : "h2"} css={styles.title}>
          {t(l.common.emailCapture.title)}
        </Typography>
        <Typography isSecondaryWeight css={styles.subTitle}>
          {t(l.common.emailCapture.subTitle)}
        </Typography>
        <form css={styles.form} onSubmit={handleSubmit}>
          <EmailInput
            label={t(l.common.emailCapture.emailLabel)}
            onChange={e => setEmail(e.target.value)}
            value={email}
            setEmail={setEmail}
            onBlur={handleEmailOnBlur}
            isDirty={isEmailDirty}
            required
            descriptiveText={t(l.sharedCommon.EmailMustHaveAt)}
          />

          <Button isFullWidth type="submit">
            {t(l.common.emailCapture.ctaText)}
          </Button>
        </form>
      </Arrange>
    </WellevateAuthWrapper>
  );
};

export { WellevateEmailCapture };
